import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const TreatmentConfigurationPage = lazy(
  () => import('~/features/configuration/pages/treatment-configuration-page'),
);

/**
 * Treatment Configuration — `/configuration/treatment`. Renders OUTSIDE the
 * Configuration Manager `manager` layout because the page brings its own
 * header + tab toggle and does not use the Platform selector.
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/treatment')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <TreatmentConfigurationPage />
    </Suspense>
  ),
});
